var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_7839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7737 28.8611C49.4784 40.0098 39.095 46.6667 28 46.6667C16.905 46.6667 6.52169 40.0098 0.22636 28.8611C-0.0746397 28.3268 -0.0746397 27.6758 0.22636 27.1414C6.52169 15.9904 16.905 9.33342 28 9.33342C39.095 9.33342 49.4784 15.9904 55.7737 27.1391C56.0747 27.6734 56.0747 28.3268 55.7737 28.8611ZM28 18.6668C22.8527 18.6668 18.6667 22.8528 18.6667 28.0001C18.6667 33.1474 22.8527 37.3334 28 37.3334C33.1474 37.3334 37.3334 33.1474 37.3334 28.0001C37.3334 22.8528 33.1474 18.6668 28 18.6668Z",
    fill: "#558C90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6667 37.3333C52.3787 37.3333 51.3334 38.3787 51.3334 39.6667V49C51.3334 50.2857 50.2857 51.3333 49 51.3333H39.6667C38.3787 51.3333 37.3334 52.3787 37.3334 53.6667C37.3334 54.9547 38.3787 56 39.6667 56H49C52.8594 56 56 52.8593 56 49V39.6667C56 38.3787 54.9547 37.3333 53.6667 37.3333Z",
    fill: "#558C90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 37.3333C1.04533 37.3333 0 38.3787 0 39.6667V49C0 52.8593 3.14067 56 7 56H16.3333C17.6213 56 18.6667 54.9547 18.6667 53.6667C18.6667 52.3787 17.6213 51.3333 16.3333 51.3333H7C5.71433 51.3333 4.66667 50.2857 4.66667 49V39.6667C4.66667 38.3787 3.62133 37.3333 2.33333 37.3333Z",
    fill: "#558C90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 7.62939e-05H39.6667C38.3787 7.62939e-05 37.3334 1.04541 37.3334 2.33341C37.3334 3.62141 38.3787 4.66674 39.6667 4.66674H49C50.2857 4.66674 51.3334 5.71441 51.3334 7.00008V16.3334C51.3334 17.6214 52.3787 18.6667 53.6667 18.6667C54.9547 18.6667 56 17.6214 56 16.3334V7.00008C56 3.14074 52.8594 7.62939e-05 49 7.62939e-05Z",
    fill: "#558C90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 7.62939e-05H7C3.14067 7.62939e-05 0 3.14074 0 7.00008V16.3334C0 17.6214 1.04533 18.6667 2.33333 18.6667C3.62133 18.6667 4.66667 17.6214 4.66667 16.3334V7.00008C4.66667 5.71441 5.71433 4.66674 7 4.66674H16.3333C17.6213 4.66674 18.6667 3.62141 18.6667 2.33341C18.6667 1.04541 17.6213 7.62939e-05 16.3333 7.62939e-05Z",
    fill: "#558C90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_7839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1116b235e84a33df4e44a3f016344d3c.svg";
export { ForwardRef as ReactComponent };